'use strict';

module.exports.tabsArrowKeyAccessibility = function() { // Allow tabs in tab containers to be traversed with arrow keys
  $('.nav-tabs-container .nav-link').on('keydown', function(e) {
    if (e.which === 39 || (!e.shiftKey && e.which === 9)) { // Right key or Tab
      var tabindex = $(this).attr('data-tabindex');
      tabindex++;
      var next = $('.nav-tabs-container .nav-link[data-tabindex="' + tabindex + '"]');
      if (next.length) {
        e.preventDefault();
        next.focus();
      }
    } else if (e.which === 37 || (e.shiftKey && e.which === 9)) { // Left key or Shift+Tab
        var tabindex = $(this).attr('data-tabindex');
        tabindex--;
        var next = $('.nav-tabs-container .nav-link[data-tabindex="' + tabindex + '"]');
        if (next.length) {
          e.preventDefault();
          next.focus();
        }
    }
  });
};

module.exports.sliderChangeAnnouncements = function() { // Turn off slider screenreader announcements when it is not focused/mouseover
    window.onload = (e) => { // Turn off screenreader for sliders on pageload
        $('.tns-liveregion.tns-visually-hidden').attr('aria-live', 'off');
    };

    $('.slider-container *').on('focusout mouseleave', function(e) { // Turn slider screenreader accouncements off on element within slider losing focus or mouseleave
        $(e.currentTarget).closest('.slider-container').find('.tns-liveregion.tns-visually-hidden').attr('aria-live', 'off');;
    });

    $('.slider-container *').on('focus mouseenter', function(e) { // Turn slider screenreader announcements on slider element within slider gaining focus or mouseenter
        $(e.currentTarget).closest('.slider-container').find('.tns-liveregion.tns-visually-hidden').attr('aria-live', 'polite');;
    });
};

module.exports.headerAccountDropdownKeyAccessibility = function() { // Allow header account dropdown to be opened/closed with arrow keys and Enter
  $('.header-account-container .dropdown-toggle').on('keydown', function(e) {
    if (e.which === 39 || e.which === 40) { // Right or Down key
      $('.header-account-container .dropdown-menu').addClass('show');
    }

    if (e.which === 37 || e.which === 38) { // Left or Up key
      $('.header-account-container .dropdown-menu').removeClass('show');
    }

    if (e.which === 13) { // Enter key
      $('.header-account-container .dropdown-menu').toggleClass('show');
    }
  });
};
